import React from 'react'

export const Valet = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17 6C19.6776 6 21.8629 8.10474 21.9932 10.75H17.5C15.7051 10.75 14.25 12.2051 14.25 14C14.25 15.7949 15.7051 17.25 17.5 17.25H21.9932C21.8629 19.8953 19.6776 22 17 22H7C4.23858 22 2 19.7614 2 17V11C2 8.23858 4.23858 6 7 6H17ZM6 16.75C5.58579 16.75 5.25 17.0858 5.25 17.5C5.25 17.9142 5.58579 18.25 6 18.25H12C12.4142 18.25 12.75 17.9142 12.75 17.5C12.75 17.0858 12.4142 16.75 12 16.75H6ZM22 15.75H17.5C16.5335 15.75 15.75 14.9665 15.75 14C15.75 13.0335 16.5335 12.25 17.5 12.25H22V15.75ZM17.5 13.25C17.0858 13.25 16.75 13.5858 16.75 14C16.75 14.4142 17.0858 14.75 17.5 14.75H17.7002C18.1143 14.7499 18.4502 14.4141 18.4502 14C18.4502 13.5859 18.1143 13.2501 17.7002 13.25H17.5Z'
        fill='white'
      />
      <path
        d='M19.4883 4.99449C18.7672 3.00311 16.6611 1.71747 14.4418 2.17437L5.84113 3.9451C4.04475 4.31494 2.58936 5.49917 1.82812 7.06451C3.01559 5.50677 4.89071 4.50146 7.00064 4.50146H17.0006C17.8818 4.50146 18.722 4.6768 19.4883 4.99449Z'
        fill='white'
      />
    </svg>
  )
}
